export default __webpack_public_path__ + "static/media/2.12381dd8.png";